import { merge } from '../../helper';

// ----------------------------------------------------------------------------

export type TypeReadType = 'readAsArrayBuffer' | 'readAsBinaryString' | 'readAsDataURL' | 'readAsText';

export type TypeReaderConfig = {
    merge?: any;
    readType?: TypeReadType;
    fnSuccess?: (result: any, evt: ProgressEvent<FileReader>) => void;
    fnError?: (evt: ProgressEvent<FileReader>) => void;
};

// ----------------------------------------------------------------------------

async function reader(file: File, config: TypeReaderConfig = {}): Promise<any> {
    // Default Config
    const defConfig: TypeReaderConfig = {
        readType: 'readAsArrayBuffer',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // New Promise
    const promise = new Promise(function (resolve, reject): any {
        // File Reader
        const fileReader = new FileReader();

        // Create event (load)
        fileReader.onload = function (evt): void {
            // If using function success
            if (typeof defConfig.fnSuccess === 'function') {
                defConfig.fnSuccess(fileReader.result, evt);
            }

            //
            resolve(fileReader.result);
        };

        // Create event (error)
        fileReader.onerror = function (evt): void {
            // If using function error
            if (typeof defConfig.fnError === 'function') {
                defConfig.fnError(evt);
            }

            //
            reject(new Error(`FileReader error: ${evt.type}`));
        };

        //
        if (defConfig.readType) {
            //
            fileReader[defConfig.readType](file);
        }
    });

    //
    return promise;
}

async function forReader(files: File[], config: TypeReaderConfig = {}): Promise<any> {
    const listPromises: Promise<any>[] = [];

    // Foreach Files
    for (const file of files) {
        listPromises.push(reader(file, config));
    }

    //
    return Promise.all(listPromises);
}

// ----------------------------------------------------------------------------

export { reader, forReader };
